import { ContractRequestModel, ContractsModel, ContractsOmission, ContractsResponseModel } from '../../types/contracts/contractsModel'
import { PRL_AUTO, propertyFromApi, propertyType } from '../../enums/contractsEnum'
import { PostDateRelanceModel } from '../../types/alert/alertModel'
import fetchFactory from '../../utils/fetchFactory'
import { configEnum } from '../../enums/fetchFactoryEnum'
import { roleProspectEnum } from '../profile/enums/typeProspectEnum'

export const convertContractList = (list: ContractsResponseModel[]) => list.map((item: ContractsResponseModel) => convertContract(item))

const convertContract = (contract: ContractsResponseModel): ContractsModel => ({
	id: contract.eft_Refbail.eft_bailid,
	release: 'avril 2020',
	deadline: 'mai 2020',
	type: contract.eft_Refbail.type_bien === propertyFromApi.apartment ? propertyType.apartment : contract.eft_Refbail.type_bien === propertyFromApi.local ? propertyType.local : propertyType.garage,
	onGoing: '30/04/2020',
	city: contract.eft_Refbail.eft_Referenceimmeuble.eft_commune,
	postalCode: contract.eft_Refbail.eft_Referenceimmeuble.eft_codepostal1,
	address: contract.eft_Refbail.eft_Referenceimmeuble.eft_adresse,
	lease: contract.eft_Refbail.eft_refbail,
	balance: contract.eft_solde1,
	lots: [contract.eft_Refbail.eft_reflotprincipal],
	interlocutor: contract.eft_interlocuteurid,
	codeImmeuble: contract.eft_Refbail.eft_codeimmeuble,
	residenceName: contract.eft_Refbail.eft_nomimmeuble,
	typeDePaiement: contract.eft_typedepaiement,
	buildings: contract.buildings,
	residences: contract.residences,
	portefeuille: contract.eft_Refbail.eft_Referenceimmeuble.eft_portefeuillevente,
	dateRelancePrelevement: contract.eft_date_relance_prelvement ? new Date(contract.eft_date_relance_prelvement) : null,
	dateFinAssurance: contract.eft_Refbail.eft_datefinassurance ? new Date(contract.eft_Refbail.eft_datefinassurance) : null,
	dateDeFinDuBail: contract.eft_datedefindubail ? new Date(contract.eft_datedefindubail) : null,
	dateEffet: contract.eft_Refbail.eft_dateeffet ? new Date(contract.eft_Refbail.eft_dateeffet) : null,
	dateConge: contract.eft_Refbail.eft_dateconge ? new Date(contract.eft_Refbail.eft_dateconge) : null,
	phase: contract.eft_Refbail.eft_phase,
	categorieJuridique: contract.eft_Refbail.eft_categoriejuridique ?? null,
	interlocuteursRoleBail: contract.interlocuteursBail ?? [],
	role: contract.eft_role,
	numeroDePdl: contract.numeroDePdl,
	meuble: contract.eft_Refbail.eft_Referencelotprincipal.eft_meuble ?? false,
	idLot: contract.eft_Refbail.eft_Referencelotprincipal.eft_bienid,
	jour1 : contract.eft_Refbail.eft_creneau1edljour,
	jour2 : contract.eft_Refbail.eft_creneau2edljour,
	jour3 : contract.eft_Refbail.eft_creneau3edljour,
	heure1 : contract.eft_Refbail.eft_creneau1edlheure,
	heure2 : contract.eft_Refbail.eft_creneau2edlheure,
	heure3 : contract.eft_Refbail.eft_creneau3edlheure
})

//Return number of months between two dates
const numberOfMonths = (date1: Date, date2: Date) => {
	let nbMonths = (date2.getFullYear() - date1.getFullYear()) * 12
	nbMonths -= date1.getMonth() + 1
	nbMonths += date2.getMonth() + 1
	return nbMonths <= 0 ? 0 : nbMonths
}

//Return true if number of month between dateRelacePrelement and today is >= 3 months
export const checkNbOfMonthsSinceLastDisplay = (dateRelancePrelevement: Date | null) => {
	let lastDate = new Date()
	dateRelancePrelevement ? lastDate = dateRelancePrelevement : lastDate.setMonth(lastDate.getMonth() - 3)
	return numberOfMonths(lastDate, new Date()) >= 3
}

//Return contract with payment mode != PRL_AUTO and with the latest dateRelancePrelevement
export const getLatestDateRelancePrelevement = (contracts: ContractsModel[]) => {
	return contracts.filter(contract => contract.typeDePaiement !== PRL_AUTO).reduce((a, b) =>
		(!a.dateRelancePrelevement && b.dateRelancePrelevement ? b :
			(a.dateRelancePrelevement && !b.dateRelancePrelevement ? a :
				(a.dateRelancePrelevement && b.dateRelancePrelevement && a.dateRelancePrelevement > b.dateRelancePrelevement ? a : b)))
	)
}

// Set field eft_date_relance_prelvement
export const setDateRelance = (interlocuteurid: string | undefined) => {
	const dataDateRelance: PostDateRelanceModel = {
		eft_date_relance_prelvement: new Date(),
		eft_interlocuteurid: interlocuteurid ? interlocuteurid : ''
	}
	fetchFactory(`/api/ec_${process.env.REACT_APP_TARGET}/contrat/setDateRelancePrelevement`,
		{
			body: JSON.stringify(dataDateRelance),
			method: configEnum.post
		})
}

export const contractRequestMapper = (contract: ContractRequestModel): Omit<ContractsModel, ContractsOmission> => (
	{
		id: contract.eft_Refbail.eft_bailid,
		type: contract.eft_Refbail.type_bien === propertyFromApi.apartment ? propertyType.apartment : contract.eft_Refbail.type_bien === propertyFromApi.local ? propertyType.local : propertyType.garage,
		city: contract.eft_Refbail.eft_Referenceimmeuble.eft_commune,
		postalCode: contract.eft_Refbail.eft_Referenceimmeuble.eft_codepostal1,
		address: contract.eft_Refbail.eft_Referenceimmeuble.eft_adresse,
		lease: contract.eft_Refbail.eft_refbail,
		codeImmeuble: contract.eft_Refbail.eft_codeimmeuble,
		lots: [contract.eft_Refbail.eft_reflotprincipal],
		interlocutor: contract.eft_interlocuteurid,
		typeDePaiement: contract.eft_typedepaiement,
		buildings: contract.buildings,
		residences: [contract.eft_Refbail.eft_Referenceimmeuble.eft_bienid],
		phase: contract.eft_Refbail.eft_phase,
		categorieJuridique: contract.eft_Refbail.eft_categoriejuridique ?? null,
		portefeuille: contract.eft_Refbail.eft_Referenceimmeuble.eft_portefeuillevente,
		dateRelancePrelevement: contract.eft_date_relance_prelvement ? new Date(contract.eft_date_relance_prelvement) : null,
		dateFinAssurance: contract.eft_Refbail.eft_datefinassurance ? new Date(contract.eft_Refbail.eft_datefinassurance) : null,
		dateDeFinDuBail: contract.eft_datedefindubail ? new Date(contract.eft_datedefindubail) : null,
		dateEffet: contract.eft_Refbail.eft_dateeffet ? new Date(contract.eft_Refbail.eft_dateeffet) : null,
		dateConge: contract.eft_Refbail.eft_dateconge ? new Date(contract.eft_Refbail.eft_dateconge) : null,
		interlocuteursRoleBail: contract.interlocuteursBail,
		role: roleProspectEnum.locataire,
		meuble: contract.eft_Refbail.eft_Referencelotprincipal.eft_meuble ?? false,
		idLot: contract.eft_Refbail.eft_Referencelotprincipal.eft_bienid,
		jour1: contract.eft_Refbail.eft_creneau1edljour,
		jour2: contract.eft_Refbail.eft_creneau2edljour,
		jour3: contract.eft_Refbail.eft_creneau3edljour,
		heure1: contract.eft_Refbail.eft_creneau1edlheure,
		heure2: contract.eft_Refbail.eft_creneau2edlheure,
		heure3: contract.eft_Refbail.eft_creneau3edlheure
	}
)
